<script setup lang="ts">
import AdminTopBar from '@/modules/admin/components/AdminTopBar.vue';
import AdminPanelMenu from '@/modules/admin/components/AdminPanelMenu.vue';
import { storeToRefs } from 'pinia';
import { useLoaderAtStartStore } from '@/shared/components/loaders/LoaderAtStartApp/store.ts';
import { useAdminNavStore } from '@/modules/admin/stores/admin-nav';

const { visible: loaderVisible } = storeToRefs(useLoaderAtStartStore());

loaderVisible.value = false;

const { navItems } = storeToRefs(useAdminNavStore());
</script>

<template>
  <div class="main-wrapper">
    <div>
      <AdminTopBar />
      <div class="content-wrapper">
        <AdminPanelMenu
          v-if="navItems.length"
          :nav-items="navItems"
          class="menu"
        />
        <RouterView />
      </div>
    </div>
  </div>
</template>

<style scoped>
.main-wrapper {
  position: relative;
  height: 100%;
  background-color: #eee;
}

.content-wrapper {
  display: grid;
  grid-template-columns: max-content 1fr;
  align-items: flex-start;
  justify-content: flex-start;
}

.content-wrapper:has(.menu)::v-deep(.ion-page) {
  left: 60px;
}

.menu {
  z-index: 100;
}
</style>
